import { Header } from '@Components/StickyTable';

import { renderRatio } from './streaming-discrepancies-utils';
import { StreamingDiscrepancyRow } from './use-streaming-discrepancies';

export const PAGE_TITLE = 'Streaming Discrepancies';

export const IP_FREQUENCY_DESCRIPTION = 'ip frequency';

export const HEADERS: Header[] = [
  { name: 'day', label: 'Day' },
  { name: 'company', label: 'Company', width: 150 },
  { name: 'description', label: 'Description', width: 150 },
  { name: 'network', label: 'Network', width: 200 },
  { name: 'platform', label: 'Platform', width: 200 },
  { name: 'details', label: 'Details' },
  {
    name: 'yesterday',
    label: 'Yesterday',
    flex: 1,
    renderer: (row: StreamingDiscrepancyRow) =>
      renderRatio(
        row.description === IP_FREQUENCY_DESCRIPTION,
        row.yesterday_ratio,
        row.yesterday_monitored,
        row.yesterday_total
      )
  },
  {
    name: 'last_week',
    label: 'Last Week',
    flex: 2,
    renderer: (row: StreamingDiscrepancyRow) =>
      renderRatio(
        row.description === IP_FREQUENCY_DESCRIPTION,
        row.last_week_ratio,
        row.last_week_monitored,
        row.last_week_total
      )
  }
];
